import axios from 'axios';
import { mutate } from 'swr';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { Notistack } from '@shared/components/Notistack/Notistack';

const BASE_URL = `${SERVICES.ACCOUNTING}/accounting`;

export const requestOutOfSyncData = (startDate: string | null, endDate: string | null, pathString: string) => {
  const path = `${BASE_URL}/${pathString}/outofsync`;
  const queryParams = { params: { fromDateUtc: startDate, toDateTimeUtc: endDate } };

  return mutate(path, async() => {
    try {
      const response = await axios.get(`${path}`, queryParams);
      return response?.data;
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};
